<app-input-field
  [noLabel]="true"
  [noLabelExtraSpacing]="true"
  *ngIf="!editingPath"
  class="gallery-path-field"
  [class.disabled]="gallery.public_access === 'no_access'"
>
  <div
    fake-input
    class="fake-input-path no-hover"
    [class.disabled]="gallery.public_access === 'no_access'"
    [class.copy-only]="accessLevel !== 'edit'"
  >
    <span>{{ publicLinkPre || 'Loading...' }}</span>
    <span
      class="post"
      (click)="startEditPath()"
      data-test-id="gallery-path-update"
      [appTooltip]="gallery.public_access === 'no_access' || accessLevel !== 'edit' ? '' : 'Click to rename this link'"
      >{{ publicLinkPost }}</span
    >
  </div>
  <div *appInputPost class="edit-path-buttons">
    <button
      appButton
      type="button"
      name="copy-link"
      location="editable-gallery-url-field"
      height="1"
      spacing="3"
      shape="round"
      color="primary"
      data-test-id="copy-share-link-button"
      [share]="publicLink"
      (onCopied)="onCopied()"
      [attr.test-share-content]="publicLink"
      [class.disabled]="!publicLink || gallery.public_access === 'no_access'"
    >
      <span *ngIf="!canShare">Copy</span>
      <span *ngIf="canShare">Share</span>
    </button>
  </div>
</app-input-field>

<form
  [formGroup]="pathForm"
  (ngSubmit)="savePath()"
  *ngIf="editingPath"
  class="edit-path-form show-errors-without-submitting"
>
  <app-input-field [control]="pathForm.controls.path" [noLabel]="true" [noLabelExtraSpacing]="true">
    <input
      type="text"
      formControlName="path"
      placeholder="Gallery path"
      appAutofocus
      data-test-id="gallery-path-field"
    />
    <div *appInputPost class="edit-path-buttons">
      <button
        appButton
        type="button"
        name="cancel-edit-path"
        location="editable-gallery-url-field"
        color="simple-primary"
        (click)="cancelEditPath()"
        height="1"
        shape="round"
      >
        Cancel
      </button>
      <button
        appButton
        type="button"
        name="save-path"
        location="editable-gallery-url-field"
        color="primary"
        height="1"
        weight="bold"
        shape="round"
        spacing="3"
        (click)="savePath()"
        data-test-id="save-gallery-path"
      >
        <span [class.hidden-text]="savingPath">Save</span>
        <app-loading-indicator *ngIf="savingPath" color="white" size="small" class="button-loading-indicator">
        </app-loading-indicator>
      </button>
    </div>
  </app-input-field>
</form>
